export enum METHOD {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}



// WEBPACK FOOTER //
// ./src/utils/METHOD.ts